import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { observer } from "mobx-react";
import useStore from "../../../helpers/useStore";
import { SalesStoreContext } from "../../../stores/Sales/sales.provider";
import { GiftCertificateDto } from "../../../api-client";
import FlatCard from "../../../atoms/FlatCard";

const GiftCertificatesTable = observer(
  ({ patientId, dataRefreshFlag, setDataRefreshFlag }: any) => {
    const SalesStore = useStore(SalesStoreContext);
    const { getGiftCertificatesByPatientId, updateGiftCard } = SalesStore;

    const [open, setOpen] = useState(false);
    const [giftCertificates, setGiftCertificates] = useState<GiftCertificateDto[]>([]);
    const [giftCardNumber, setGiftCardNumber] = useState("");

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
      setGiftCardNumber("");
      setOpen(false);
    };

    useEffect(() => {
      const fetchData = async () => {
        if (patientId) {
          const response = await getGiftCertificatesByPatientId(patientId);
          setGiftCertificates(response || []);
        }
      };
      fetchData();
    }, [patientId, dataRefreshFlag]);

    const handleSubmit = async () => {
      if (giftCardNumber.trim()) {
        await updateGiftCard(patientId, giftCardNumber);
        setGiftCardNumber("");
        setOpen(false);
        setDataRefreshFlag((prev: boolean) => !prev);
      }
    };

    const formatCurrency = (amount: number) =>
      new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(amount);

    return (
      <>
        <FlatCard title={undefined}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: "1rem" }} >Code</TableCell>
                <TableCell sx={{ fontSize: "1rem" }}>Datum</TableCell>
                <TableCell sx={{ fontSize: "1rem" }}>Ursprungswert</TableCell>
                <TableCell sx={{ fontSize: "1rem" }}>Restwert</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {giftCertificates.map((card, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell sx={{ fontSize: "1rem" }}>{card.codeLowSecurity}</TableCell>
                    <TableCell sx={{ fontSize: "1rem" }}>
                      {card.createdAt ? new Date(card.createdAt).toLocaleDateString("de-DE") : ""}
                    </TableCell>
                    <TableCell sx={{ fontSize: "1rem" }}>{formatCurrency(card.value || 0)}</TableCell>
                    <TableCell sx={{ fontSize: "1rem" }}>
                      {card.remainingAmount ? formatCurrency(card?.remainingAmount) : 0}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Button onClick={handleOpen} variant="contained" style={{ float: "right", marginTop: 8 }}>
            <AddIcon />
          </Button>
        </FlatCard>
        {/* Add Gift Card Dialog */}
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Geschenkgutschein zuweisen</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              label="Geschenkkartennummer"
              value={giftCardNumber}
              onChange={(e) => setGiftCardNumber(e.target.value)}
              autoFocus
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Abbrechen</Button>
            <Button variant="contained" onClick={handleSubmit}>
              Hinzufügen
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
);

export default GiftCertificatesTable;
